import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import styled from "styled-components";
import { HeaderItemCss } from "./styled";
export var HeaderToggleItem = function(param) {
    var onToggle = param.onToggle, showToggleChild = param.showToggleChild, toggleChild = param.toggleChild, children = param.children, className = param.className, id = param.id;
    return /*#__PURE__*/ _jsxs(HeaderToggleItemContainer, {
        className: className,
        children: [
            /*#__PURE__*/ _jsx(HeaderToggleButton, {
                onClick: onToggle,
                "data-test-id": id,
                children: children
            }),
            showToggleChild ? toggleChild : null
        ]
    });
};
var HeaderToggleItemContainer = styled.div.withConfig({
    componentId: "sc-72aa5d6d-0"
})([
    "position:relative;"
]);
var HeaderToggleButton = styled.button.withConfig({
    componentId: "sc-72aa5d6d-1"
})([
    "",
    ""
], HeaderItemCss);
